<template>
  <div class="flex flex-row items-center gap-2">
    <button-v2
      v-for="category in categories"
      :key="category"
      :variant="category === value ? 'filled' : 'ghost'"
      size="sm"
      @click="$emit('input', category)"
    >
      {{ $t(`INTEGRATION_SETTINGS.LIST.CATEGORIES.${category.toUpperCase()}`) }}
    </button-v2>
  </div>
</template>

<script>
import { INTEGRATION_CATEGORIES } from '../constants';

export default {
  name: 'CategoryFilter',
  props: {
    value: { type: String, default: 'all' },
    categories: { type: Array, default: () => INTEGRATION_CATEGORIES },
  },
};
</script>
